import { render } from "./PaymentFailed.vue?vue&type=template&id=2ba86035&scoped=true"
const script = {}

import "./PaymentFailed.vue?vue&type=style&index=0&id=2ba86035&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ba86035"]])

export default __exports__